import {
  useStyle 
} from "@/classify"
import Button from "../Button"
import defaultClasses from "./linkButton.module.css"

const LinkButton = (props) => {
  const {
    children,
    classes: propClasses,
    type = "button",
    ...restProps
  } = props
  const classes = useStyle(defaultClasses, propClasses)

  return (
    <Button
      priority={"normal"}
      classes={{
        root_normalPriority: classes.root 
      }}
      type={type}
      {...restProps}
    >
      {children}
    </Button>
  )
}

export default LinkButton
